import type { FaireProductEntity } from "../../entity_types/product";

export const p_x6jnvaenpu: FaireProductEntity = {
  token: "p_x6jnvaenpu",
  type: "product",
  name: "Oval Evil Eye Ring",
  brandToken: "b_ur24ckegrz",
  brandName: "Evileyefavor",
  imageUrl: "https://cdn.faire.com/fastly/1050cc3733eb905197546ea03f7f138bb55b0015e16da5cc3c3d2708bb4e0c34.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56bab0c26396ea44982c0ee385ff9d1a70fb4ef16c746c5436b428e394d0372f.jpeg",
    "https://cdn.faire.com/fastly/7396c68a2f79e5578adb526394aecd0ca12c4cb1b4a11e6636a1a516c04d45a8.jpeg",
    "https://cdn.faire.com/fastly/849e25ae27cfe7d6078dac938af7c08b0cfb2e56d485283470ca7dfe92fe1d85.jpeg",
    "https://cdn.faire.com/fastly/0162a5a12aed9722203240ceea3a7c973eae0b9a652dea000c4b42697d5801bc.jpeg",
    "https://cdn.faire.com/fastly/20966538c06142702fa416ce03203ea9850c3290c87f861445f4dc27c8672a54.jpeg"
  ],
  priceDollars: 9.06,
  description: "Adjustable ring, evil eye ring, blue evil eye, evil eye jewelry, greek evil eye, white evil eye, rose gold ring, dainty ring, good luck jewelry\n\n🌟 Two colors available, please choose during check out; \n- Blue \n- White \n\n🌟 These evil eye ring include: \n- rose gold beads \n- oval blue/ white evil eye bead \n\n🌟 These evil eye rings are ADJUSTABLE. These are suitable for every sizes. \n\n🌟 These evil eye rings can be used as JOINT RINGS as well.\"\"",
  tags: [],
  msrpDollars: 15.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:43.519Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
